import { useEffect, useRef } from "react";

export function useInfiniteScroll(callback: () => void, loading: boolean) {
  const observerRef = useRef<IntersectionObserver | null>(null);
  const bottomRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (loading) return;

    observerRef.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) callback();
    });

    if (bottomRef.current) observerRef.current.observe(bottomRef.current);

    return () => observerRef.current?.disconnect();
  }, [callback, loading]);

  return bottomRef;
}
